export default "__VITE_PUBLIC_ASSET__738a5007__"